import React from "react";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const TyresLocation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
  const BASEURL_GLOBAL =  process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const [layoutdata, setLayoutData] = useState([]);
  const [layout, setLayout] = useState("");
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1375`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        const uniqueData = new Set(res?.data?.map((item) => item?.LAYOUT));
        setLayoutData([...uniqueData]);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error While fetching 1375", err);
        setIsLoading(false);
      });
  };

  function getDataByLayout(lay) {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1375&LAYOUT=${lay}`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setData(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error While fetching 1375", err);
        setIsLoading(false);
      });
  }

  return (
    <div className="text-xs">
      <div className="lg:flex lg:flex-col mt-3 justify-between bg-gray-100 p-2 m-2 rounded-md">
        {/* 1st Row  */}
        <div className="flex">
          <span className="lg:ml-2">Vehicle Layout:</span>

          <Select
            className="w-80"
            value={
              layout
                ? { value: layout, label: layout }
                : { value: "", label: "Select Layout" }
            }
            onChange={(e) => {
              if (e.value !== "") {
                getDataByLayout(e.value);
                setLayout(e.value);
              } else {
                setLayout(e.value);
              }
            }}
            options={[
              { value: "", label: "Select Layout" },
              ...layoutdata?.map((item) => ({
                value: item,
                label: item,
              })),
            ]}
          ></Select>
        </div>
      </div>
        <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4  border border-gray-300 text-left">S NO</td>
              <td className="py-2 px-4  border border-gray-300 text-left">LOCATION</td>
            </tr>
          </thead>
          <tbody>
            {data?.map((row, index) => (
              <tr
                className="hover:bg-gray-100 cursor-pointer text-[12px]"
                key={index}
                // onClick={() => {
                //   setContractno(row?.LOCATION);
                // }}
              >
                <td className="py-2 px-4  border border-gray-300 text-right">{index + 1}</td>
                <td className="py-2 px-4  border border-gray-300 text-left">{row?.LOCATION ? row?.LOCATION : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </aside>
    </div>
  );
};

export default TyresLocation;
